import store from '@/store.js'
import { featuresEnum } from '@/utils/featureUtils'

const Index = () => import('./pages/Index.vue')

const ChooseMethods = () => import('./pages/import-contacts/ChooseMethods.vue')
const ImportContacts = () => import('./pages/import-contacts/ImportContacts.vue')
const Organize = () => import('./pages/import-contacts/Organize.vue')
const Complete = () => import('./pages/import-contacts/Complete.vue')

const TheContainer = () => import('@/containers/TheContainer')
const EmptyContainer = () => import('@/containers/EmptyContainer')
const TheMainSidebar = () => import('@/containers/TheMainSidebar') //barra esq
const TheMainAsideBar = () => import('@/containers/TheMainAsideBar') //barra dir
const TheMainSidebarAndAsidebar = () => import('@/containers/TheMainSidebarAndAsidebar') // ambas as barras

const AudienceDashboard = () => import('./pages/AudienceDashboard.vue')

const AudienceList = () => import('./pages/AudienceList.vue')
const AudienceDetail = () => import('./pages/AudienceDetail.vue')
const ImportHistory = () => import('./pages/ImportHistory.vue')
const CustomFields = () => import('./pages/CustomFields.vue')

const AudienceStart = () => import('./pages/AudienceStart.vue')
const SegmentsList = () => import('./pages/SegmentsList.vue')
const SegmentsDetails = () => import('./pages/SegmentsDetails.vue')

const Segments = () => import('./pages/Segments.vue')
const SegmentsEdit = () => import('./pages/SegmentsEdit.vue')

const TheContainerFluid = () => import('@/containers/TheContainerFluid')

const audienceRoutes = [
  {
    path: 'audience',
    component: TheContainerFluid,
    children: [
      // audience
      {
        path: '/',
        component: Index,
        meta: { requiresAuth: true },
        children: [
          {
            path: '/',
            name: 'audience',
            component: AudienceList,
            meta: { requiresAuth: true, name: 'audience.routes.name.audience' },
          },
          {
            path: 'contact-detail/:id',
            name: 'contact-detail',
            component: AudienceDetail,
            meta: { requiresAuth: true, name: 'audience.routes.name.AudienceDetail' },
            props: { default: true, organizationId: store.state.auth.organizationId },
          },
          {
            path: 'import-history',
            name: 'import-history',
            component: ImportHistory,
            meta: { requiresAuth: true, name: 'audience.routes.name.ImportHistory' },
          },
          {
            path: 'audience/custom-fields',
            name: 'custom-fields',
            component: CustomFields,
            meta: { requiresAuth: true, name: 'audience.routes.name.CustomFields' },
            props: { organizationId: store.state.auth.organizationId },
          },
        ],
      },
      // smart audience
      // Create audience
      {
        path: 'import-contacts',
        name: 'import-contacts',
        redirect: 'import-contacts/choose-methods',
        component: Index,
        meta: { requiresAuth: true, name: 'audience.routes.name.import-contacts' },
        children: [
          {
            path: 'choose-methods',
            name: 'choose-methods',
            component: ChooseMethods,
            meta: { requiresAuth: true, name: 'audience.routes.name.import-contacts' },
          },
          {
            path: 'import/:type?',
            name: 'import',
            component: ImportContacts,
            meta: { requiresAuth: true },
          },
          {
            path: 'organize',
            name: 'organize',
            component: Organize,
            meta: { requiresAuth: true, name: 'audience.routes.name.import-contacts' },
          },
          {
            path: 'complete',
            name: 'complete',
            component: Complete,
            meta: { requiresAuth: true, name: 'audience.routes.name.import-contacts' },
          },
        ],
      },
      // segments
      {
        path: 'segments',
        name: 'segments-list',
        component: SegmentsList,
        meta: { requiresAuth: true },
        props: true,
      },
      {
        path: 'segments',
        component: TheMainAsideBar,
        meta: { requiresAuth: true },
        props: { default: true, AsidebarComponente: 'AsideSegments' },
        children: [
          {
            path: 'create/:campaignId?',
            name: 'segment-create',
            component: Segments,
            meta: { requiresAuth: true },
          },
          {
            path: 'edit/:id/:segmentIdGuid',
            name: 'segments-edit',
            component: SegmentsEdit,
            meta: { requiresAuth: true },
          },
          {
            path: 'details/:id/:segmentIdGuid',
            name: 'segments-details',
            component: SegmentsDetails,
            meta: { requiresAuth: true },
          },
        ],
      },
    ],
  },
]

export default audienceRoutes
